import { render } from "./AtualizaFotoAluno.vue?vue&type=template&id=4383269c"
import script from "./AtualizaFotoAluno.vue?vue&type=script&lang=js"
export * from "./AtualizaFotoAluno.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__